import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Segment, Loader} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';

class PartEquivalences extends Component {
  componentDidMount() {
    const {partCode} = this.props;
    this.props.getPartEquivalences(partCode);
  }

  componentDidUpdate(prevProps) {
    const {partCode} = this.props;
    if (partCode !== prevProps.partCode) {
      this.props.getPartEquivalences(partCode);
    }
  }

  renderItems() {
    const {equivalences} = this.props;
    
    if (!equivalences.length) {
      return (
        <Segment>
          No hay repuestos equivalentes
        </Segment>
      );
    }

    return equivalences.map((part) => (
      <Segment key={part.code}>
        {part.code}
      </Segment>
    ));
  }

  renderLoaderOrItems() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Loader active inline='centered'>
          Consultando los items equivalences del repuesto.
        </Loader>
      );
    }
    return this.renderItems();
  }

  render() {
    return (
      <div>
        <h3>Equivalente:</h3>
        <Segment.Group>
          {this.renderLoaderOrItems()}
        </Segment.Group>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.partsMaster.loadingEquivalences,
    'equivalences': state.partsMaster.equivalences,
  };
};

const {getPartEquivalences} = Actions;

export default connect(mapStateToProps, {getPartEquivalences})(PartEquivalences);
